export const BUTTON_TEXT = {
  COPY: "Copy",
  INSERT: "Insert",
  REPHRASE: "Rephrase",
  SEE_MORE: (n?: number) => (n ? `Show ${n} More` : "Show More"),
  SEE_LESS: "Show Less",
};
